import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, FormControl, InputLabel, MenuItem, Select, TextField, Button, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Paper, CircularProgress, IconButton, Dialog, DialogActions, DialogContent } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import moment from 'moment';
import 'moment/locale/es-mx';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { usePages } from '../../hooks/usePages';

import { DownloadFile } from '../../helpers/DownloadFile';
import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { TableTheadStyle, TablePaddingStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';

import { DialogDocumento } from '../../dialogs/DialogDocumento';
import { DialogExhortoRecibido } from '../../dialogs/DialogExhortoRecibido';
import { DialogExpediente } from '../../dialogs/DialogExpediente';

import { ObtenerMateria } from '../../connections/catalogos/MateriaConnection';
import { ObtenerTipoExhorto } from '../../connections/catalogos/TipoExhortoConnection';
import { ObtenerAutoridadesMaterias } from '../../connections/catalogos/AutoridadConnection';
import { ObtenerLibroExhortosLibrados, DescargarLibroExhortosLibrados, GuardarObservacionesLibroExhortosLibrados } from '../../connections/libros-electronicos/LibroExhortosLibradosConnection';

import { MateriaProps } from '../../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { TipoExhortoProps } from '../../interfaces/catalogos/TipoExhortoInterface';
import { defaultLibroExhortosLibrados, LibroExhortosLibradosProps } from '../../interfaces/libros-electronicos/LibroExhortosLibradosInterface';

export const LibroExhortosLibradosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [loading, setLoading] = useState( false );
    const [searching, setSearching] = useState( false );
    const [loadingDescarga, setLoadingDescarga] = useState( false );
    const [loadingObservaciones, setLoadingObservaciones] = useState( false );

    const [openDialogObservaciones, setOpenDialogObservaciones] = useState( false );
    const [openDialogExhortoRecibido, setOpenDialogExhortoRecibido] = useState( false );
    const [openDialogExpediente, setOpenDialogExpediente] = useState( false );
    const [openDialogDocumento, setOpenDialogDocumento] = useState( false );

    const [documento, setDocumento] = useState( '' );

    const [filtroAplicado, setFiltroAplicado] = useState( false );
    const [recordCount, setRecordCount] = useState( 0 );

    const [numeroReferencia, setNumeroReferencia] = useState( '' );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoExhortoProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [libroExhortosLibradosSelected, setLibroSelected] = useState<LibroExhortosLibradosProps>( defaultLibroExhortosLibrados );

    const [rows, setRows] = useState<LibroExhortosLibradosProps[]>( [] );
    const [observaciones, setObservaciones] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClear = () => {

        setNumeroReferencia( '' );

        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );
        setTipoConsecutivo( 0 );

        resetPage();
        setFiltroAplicado( false );

    }

    const handleBuscar = async () => {

        setSearching( true );
        setLoading( true );
        setRecordCount( 0 );
        setRows( [] );
        setFiltroAplicado( true );

    }

    const handleDescargar = async () => {

        setLoadingDescarga( true );

        await DescargarLibroExhortosLibrados({ idAutoridad: autoridad, numeroReferencia, idTipoConsecutivo: tipoConsecutivo }).then( resp => {

            setTimeout(() => {

                if ( resp ) {

                    DownloadFile( `Libro-exhortos-librados-${ Date.now() }.xlsx`, resp );

                    setLoadingDescarga( false );

                }
                else {

                    setLoadingDescarga( false );
                }

            }, 700);

        });

    }

    const handleOpenExhortoRecibido = ( value: LibroExhortosLibradosProps ) => {

        setLibroSelected( value );
        setOpenDialogExhortoRecibido( true );

    }

    const handleOpenExpediente = ( value: LibroExhortosLibradosProps ) => {

        setLibroSelected( value );
        setOpenDialogExpediente( true );

    }

    const handleOpenObservaciones = ( value: LibroExhortosLibradosProps ) => {

        setLibroSelected( value );
        setObservaciones( value.observaciones ?? '' );
        setOpenDialogObservaciones( true );

    }

    const handleGuardarObservaciones = async () => {

        setLoadingObservaciones( true );

        await GuardarObservacionesLibroExhortosLibrados({ id: libroExhortosLibradosSelected.idLibroExhortoLibrado, observaciones }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setOpenDialogObservaciones( false );
                    setLoadingObservaciones( false );

                    const newRows = rows.map( (elem) => {
                        if ( elem.idLibroExhortoLibrado === libroExhortosLibradosSelected.idLibroExhortoLibrado ) {
                            return { ...elem, observaciones: observaciones };
                        }
                        return elem;
                    });
                    setRows( newRows );

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'success' }));
                    setLoadingObservaciones( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoExhorto().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        Obtener();

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroExhortosLibrados({ idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );

                }, 700);

            });

        }

        if ( !filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, page, rowsPerPage ])

    useEffect(() => {

        async function Obtener() {

            setLoading( true );
            setRecordCount( 0 );
            setRows( [] );

            await ObtenerLibroExhortosLibrados({ idAutoridad: autoridad, numeroReferencia, idTipoConsecutivo: tipoConsecutivo, page, rowsPerPage }).then( resp => {

                setTimeout(() => {

                    setRecordCount( resp.recordCount );
                    setRows( resp.records );

                    setLoading( false );
                    setSearching( false );

                }, 700);

            });

        }

        if ( filtroAplicado ) {
            Obtener();
        }

    }, [ filtroAplicado, autoridad, numeroReferencia, tipoConsecutivo, page, rowsPerPage ])

    return (
        <Layout breadcrumbs={ [{ text: 'Libros electrónicos' }, { text: 'Libro de exhortos librados' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                {
                    ( administrador || coordinador )
                    &&
                        <Grid size={{ md: 12, xs: 12 }} textAlign={ 'start' }>

                            <Button startIcon={ <UndoIcon />} color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>

                        </Grid>
                }

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={<Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}> Filtro(s) </Typography>}
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>
                                        <InputLabel>Materia</InputLabel>

                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( e.target.value ) }
                                            disabled={ filtroAplicado }

                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter(({ idMateria }) => idMateria === 5 || idMateria === 6)
                                                .map(({ idMateria, descripcion }) => (
                                                    <MenuItem key={ idMateria } value={ idMateria }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ materia === 0 || filtroAplicado }>
                                        <InputLabel>Autoridad</InputLabel>

                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map(({ idAutoridad, descripcion }) => (
                                                    <MenuItem key={ idAutoridad } value={ idAutoridad }>{ descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth disabled={ filtroAplicado }>
                                        <InputLabel>Tipo de consecutivo</InputLabel>

                                        <Select
                                            label='Tipo de consecutivo'
                                            value={ tipoConsecutivo }
                                            onChange={ (e) => setTipoConsecutivo( e.target.value ) }
                                        >
                                            <MenuItem value={ 0 }>Selecciona una opción</MenuItem>

                                            {
                                                tipoConsecutivoArray.map(({ idTipoExhorto, descripcion }) => (
                                                    <MenuItem key={ idTipoExhorto } value={ idTipoExhorto }>
                                                        {
                                                            descripcion.toLocaleLowerCase().includes('recibido') ? 'Número de exhorto recibido' :
                                                            descripcion.toLocaleLowerCase().includes('librado') ? 'Número de exhorto librado' : ''
                                                        }
                                                    </MenuItem>
                                                ))
                                            }

                                            {
                                                tipoConsecutivoArray.length !== 0
                                                &&
                                                    <MenuItem value={ 3 }>Número de expediente</MenuItem>
                                            }

                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label='Número de referencia'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        value={ numeroReferencia }
                                        onChange={ (e) => setNumeroReferencia( e.target.value ) }
                                        disabled={ filtroAplicado || tipoConsecutivo === 0 }
                                        onKeyDown={ (e) => e.key === 'Enter' ? handleBuscar() : {} }
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <Button
                                        fullWidth
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        loading={ searching }
                                        disabled={ autoridad === 0 && numeroReferencia.trim() === '' }
                                        onClick={ () => { filtroAplicado ? handleClear() : handleBuscar() } }
                                    >
                                        { filtroAplicado ? 'Limpiar filtro' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        color='secondary'
                        variant='outlined'
                        loading={ loadingDescarga }
                        onClick={ handleDescargar }
                    >
                        Descargar información
                    </Button>

                </Grid>

                <Grid size={{ md: 12, xs: 12 }}>

                    <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>

                        <Table sx={{ minHeight: rows.length === 0 ? 450 : 0 }}>

                            <TableHead sx={{ ...TableTheadStyle }}>

                                <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Exhorto librado</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Fecha</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Autoridad Requerida</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Clase</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Objeto</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Observaciones</TableCell>
                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>

                                </TableRow>

                            </TableHead>

                            <TableBody>

                                {
                                    rows.map( ( elem , index) => {

                                        const { numeroExhorto, numeroReferencia, fecha, autoridadRequerida, claseExhorto, objetoExhorto, observaciones, esExhortoRecibido, documento: doc } = elem;

                                        return <TableRow key={ index } >

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Typography variant='subtitle1'>
                                                    <strong>{ numeroExhorto }</strong>
                                                </Typography>

                                                {
                                                    doc
                                                    &&
                                                        <Button
                                                            variant='contained'
                                                            size='small'
                                                            color='primary'
                                                            sx={{ mt: 1 }}
                                                            onClick={ () => { setDocumento( doc ); setOpenDialogDocumento( true ); } }
                                                        >
                                                            Ver documento
                                                        </Button>
                                                }

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                <Button
                                                    fullWidth
                                                    variant='contained'
                                                    onClick={ () => esExhortoRecibido ? handleOpenExhortoRecibido( elem ) : handleOpenExpediente( elem ) }
                                                >
                                                    { numeroReferencia }
                                                </Button>

                                            </TableCell>

                                            <TableCell sx={{ textAlign: 'center' }}>

                                                {
                                                    fecha
                                                    &&
                                                        <>

                                                            <Typography variant='subtitle1'>
                                                                { moment( fecha ).format( 'DD-MM-YYYY' ) }
                                                            </Typography>

                                                            <Typography variant='caption' color='text.secondary'>
                                                                { moment( fecha ).format( 'hh:mm a' ) }
                                                            </Typography>

                                                        </>
                                                }

                                            </TableCell>

                                            <TableCell> { autoridadRequerida } </TableCell>

                                            <TableCell> { claseExhorto } </TableCell>

                                            <TableCell> { objetoExhorto } </TableCell>

                                            <TableCell sx={{ whiteSpace: "normal", wordBreak: "break-word" }}> { observaciones } </TableCell>

                                            <TableCell>

                                                <IconButton color='primary' onClick={ () => handleOpenObservaciones( elem ) }>
                                                    <EditIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    })
                                }

                                {
                                    ( rows.length === 0 && !loading )
                                    ?
                                        <TableRow style={{ height: 73 }}>

                                            <TableCell colSpan={ 8 } align='center'>

                                                <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                            </TableCell>

                                        </TableRow>
                                    :
                                        loading
                                        &&
                                            <TableRow style={{ height: 73 }}>

                                                <TableCell colSpan={ 8 } align='center'>

                                                    <CircularProgress size={ 32 } />

                                                </TableCell>

                                            </TableRow>
                                }

                            </TableBody>

                            <TableFooter>

                                <TableRow>

                                    <TableCell colSpan={ 2 }>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { recordCount } </Typography>
                                    </TableCell>

                                    <TablePagination
                                        colSpan={ 6 }
                                        rowsPerPageOptions={ [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500 ] }
                                        count={ recordCount }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }
                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage='Filas por página'
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                            }
                                        }
                                    />

                                </TableRow>

                            </TableFooter>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <DialogDocumento
                documento={ documento }
                openDialog={ openDialogDocumento }
                handleCloseDialog={ () => setOpenDialogDocumento( false ) }
            />

            <DialogExhortoRecibido
                exhortoRecibido={ libroExhortosLibradosSelected.exhortoRecibido }
                openDialog={ openDialogExhortoRecibido }
                handleCloseDialog={ () => setOpenDialogExhortoRecibido( false ) }
            />

            <DialogExpediente
                expediente={ libroExhortosLibradosSelected.expediente }
                openDialog={ openDialogExpediente }
                handleCloseDialog={ () => setOpenDialogExpediente( false ) }
            />

            <Dialog
                fullWidth
                maxWidth='sm'
                open={ openDialogObservaciones }
            >

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 1 }}
                        label='Observaciones'
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ observaciones }
                        onChange={ (e) => setObservaciones( e.target.value ) }
                        slotProps={{
                            input: { autoComplete: 'off' },
                            inputLabel: { shrink: true }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button color='secondary' disabled={ loadingObservaciones } onClick={ () => setOpenDialogObservaciones( false ) }>Cancelar</Button>
                    <Button variant='contained' loading={ loadingObservaciones } onClick={ handleGuardarObservaciones }>Guardar</Button>

                </DialogActions>

            </Dialog>

        </Layout>
    )
}
